<script>
import baseList from "@/views/components/base/baseList.vue";
import CommissionsTemplate from "@/views/components/common/form/CommissionsTemplate.vue";
import dayjs from "dayjs";
import config from "../../../../config";
export default {
  extends: baseList,
  components: {
    baseList,
  },
  data() {
    return {
      authid: "",
      menus: [
        {
          label: "本月利润",
          name: "costing_list",
          auth: "",
        },
        {
          label: "当月收入",
          name: "MonthlyIncome_list",
          auth: "",
        },
        {
          label: "物资成本",
          name: "Consumablescost_list",
          auth: "",
        },
        {
          label: "服务成本",
          name: "Cost_list",
          auth: "",
        },
        {
          label: "销售佣金",
          name: "Commissions_list",
          auth: "",
        },
      ],
      table: {
        mname: "",
        key: "id",
        url: { list: "/admin/system/payroll/customerList?type=2" },
        output: false,
      },
      actions: [
        {
          label: "新增",
          icon: "md-add",
          type: "info",
          onClick: this.toAdd,
          auth: "",
        },
        {
          label: "下载模版",
          type: "info",
          icon: "md-log-out",
          onClick: this.toDownload,
        },
        {
          label: "导入",
          icon: "md-cloud-upload",
          onClick: this.toImport,
          auth: "",
          type: "info",
        },
      ],
      filters: [
        {
          label: "医院名称",
          KeyEnter: this.search,
          name: "customerId",
          value: "",
          type: "select",
          dropList: [],
        },
        {
          label: "月份",
          KeyEnter: this.search,
          name: "monthNum",
          value: "",
          type: "select",
          dropList: [
            {
              name: "1月",
              value: "1",
            },
            {
              name: "2月",
              value: "2",
            },
            {
              name: "3月",
              value: "3",
            },
            {
              name: "4月",
              value: "4",
            },
            {
              name: "5月",
              value: "5",
            },
            {
              name: "6月",
              value: "6",
            },
            {
              name: "7月",
              value: "7",
            },
            {
              name: "8月",
              value: "8",
            },
            {
              name: "9月",
              value: "9",
            },
            {
              name: "10月",
              value: "10",
            },
            {
              name: "11月",
              value: "11",
            },
            {
              name: "12月",
              value: "12",
            },
          ],
        },
        {
          label: "年份",
          KeyEnter: this.search,
          name: "yearNum",
          value: "",
          type: "datetimeyear",
        },
      ],
      tableCols: [
        {
          title: "序号",
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "日期",
          minWidth: 90,
          align: "center",
          key: "monthTime",
        },
        {
          title: "医院名称",
          minWidth: 240,
          align: "left",
          render: (h, params) => {
            const row = params.row;
            const text = row.customerName;
            return (
              <p style="color:#3591f1; cursor: pointer;" onClick={() => this.goInfo(row)}>
                {text}
              </p>
            );
          },
        },
        /*   {
          title: "总金额",
          minWidth: 180,
          align: "center",
          key: "contractMoney",
        }, */
        {
          title: "月收入",
          minWidth: 180,
          align: "center",
          key: "monthRevenue",
          render: (h, params) => {
            const row = params.row;
            const budget = row.monthRevenue;
            const num = new Intl.NumberFormat("zh-CN", {
              style: "currency",
              currency: "CNY",
            }).format(budget);
            return (
              <div>
                <p style={{ "font-size": "14px" }}>{num}</p>
              </div>
            );
          },
        },
        /*  {
          title: "佣金点",
          minWidth: 180,
          align: "center",
          key: "payProportion",
          render: (h, params) => {
            const row = params.row.payProportion ? params.row.payProportion : 0;
            return <span>{row}%</span>;
          },
        }, */
        {
          title: "佣金",
          minWidth: 180,
          align: "center",
          key: "totalMoney",
          render: (h, params) => {
            const row = params.row;
            const budget = row.totalMoney;
            const num = new Intl.NumberFormat("zh-CN", {
              style: "currency",
              currency: "CNY",
            }).format(budget);
            return (
              <div>
                <p style={{ "font-size": "14px" }}>{num}</p>
              </div>
            );
          },
        },
      ],
    };
  },
  created() {
    this.query1 = {};
    this.deskChange();
    this.query = { type: 2 };
  },
  methods: {
    toDownload() {
      window.location.href =
        config.API_HOST + `/admin/system/payroll/template/fileDownload`;
    },
    //导入
    toImport() {
      this.$Modal.success({
        closable: true,
        title: "导入模板",
        width: "1200px",
        height: "900px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <CommissionsTemplate
              style={{ margin: "0", color: "#19be6b" }}
              refListTable={() => {
                this.search();
              }}
            ></CommissionsTemplate>
          );
        },
      });
    },
    timeDateChangeYear(val, name) {
      this.query.yearNum = val;
    },
    deskChange() {
      let q = {};
      $utils.api.load("/admin/system/customer/list", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.customerName;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.filters.length; index++) {
            const element = this.filters[index];
            if (element && element.name == "customerId") {
              this.filters[index]["dropList"] = (element["dropList"] || []).concat(
                dropList
              );
            }
          }
        }
      });
    },
    toAdd() {
      $utils.url.push({ name: "add_Commissions", query: { action: "add", type: 2 } });
    },
    goInfo(row) {
      let time = row.monthTime;
      // this.query.monthTime == null ? dayjs().format("YYYY-MM") : this.query.monthTime;
      $utils.url.push({
        name: "saleInfoList",
        query: {
          customerId: row.customerId,
          customerName: row.customerName,
          type: 2,
          monthTime: time,
        },
      });
    },
  },
};
</script>
